<template>
    <div>
        <MobileTitleWithBack v-if="$vuetify.breakpoint.xsOnly">
            Alert Preferences
        </MobileTitleWithBack>
        <v-row
            :class="$vuetify.breakpoint.smAndUp ? 'pl-8' : ''"
        >
            <v-col
                v-if="$vuetify.breakpoint.smAndUp"
                cols="4"
            >
                <ProfileNavigation selected-tab="alert-preferences" />
            </v-col>
            <v-col>
                <AlertPreferences />
            </v-col>
        </v-row>
    </div>
</template>
<script>
import MobileTitleWithBack from '@/components/MobileTitleWithBack';
import ProfileNavigation from '@/components/ProfileSettings/ProfileNavigation';
import AlertPreferences from '@/components/ProfileSettings/AlertPreferences';

export default {
    components: {
        MobileTitleWithBack,
        ProfileNavigation,
        AlertPreferences,
    },
};
</script>
